import z from "zod";

export const GetAIFeedbackResponseSchema = z.object({
  is_submitted: z.boolean(),
  feedback_value: z.string().nullish(),
  full_form: z.object({
    good_form: z.array(
      z.object({
        label: z.string(),
        type: z.string(),
        value: z.string().nullable(),
      })
    ),
    bad_form: z.array(
      z.object({
        label: z.string(),
        type: z.string(),
        value: z.string().nullable(),
      })
    ),
  }),
});

export type GetAIFeedbackResponse = z.infer<typeof GetAIFeedbackResponseSchema>;
